<modal-container
  #modalHsSync
  [headerIconClass]=""
  [headerTitle]="'automatic-orders.product.connect.header'"
  [isLargeModal]="true"
  [hasBackdrop]="true"
  [ignoreBackdropClick]="false"
  [isModalInModal]="true"
  [isHideBtnHidden]="true"
>
  <ng-container class="modal-button-show">
    <!--    <btn-->
    <!--      class="btn text-nowrap"-->
    <!--      [classes]="['btn-first', 'mr-2']"-->
    <!--      [icon]="'fa-pencil'"-->
    <!--      [label]="''"-->
    <!--      [title]="'automatic-orders.product.showModal.TMP' | translate"-->
    <!--      (click)="showChildModal()"-->
    <!--    ></btn>-->
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="text-sm mb-4">{{ 'automatic-orders.product.connect.subheader' | translate }}</div>
    <div class="card">
      <div class="row">
        <div class="col-12">
          <form-row-input
            [label]="'automatic-orders.product.search' | translate"
            [model]="searchPhrase"
            (modelChange)="searchPhrase = $event; templateSearchChange()"
            [appendBtnIcon]="'far-search'"
            [appendBtnTitle]="'automatic-orders.product.search' | translate"
            [appendBtnClasses]="['btn-search']"
            (onAppendBtnEvent)="templateSearchChange()"
            (onKeyPress)="templateSearchChange()"
          ></form-row-input>
        </div>
      </div>
      <div>
        <div class="row" *ngIf="isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <!--                  <th class="fixed-column-width" scope="col">&nbsp;</th>-->
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th class="fixed-column-width" scope="col">&nbsp;</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div class="empty-list gray">
                        <!--                      fuck this shit:-->
                        <!--                      <loading-spinner [isLoading]="true" [classesString]="'spinner-box'"></loading-spinner>-->
                        <div class="spin spinner-box">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <!--                  <th class="fixed-column-width" scope="col">&nbsp;</th>-->
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th class="fixed-column-width" scope="col">&nbsp;</th>
                  </tr>
                </thead>

                <tbody *ngIf="searchPhrase?.length < 1 && templates?.length === 0">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-arrow-up gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.doSearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="searchPhrase?.length > 0 && templates?.length === 0 && isNotFound">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-box-open gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.emptySearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="templates?.length > 0" class="images" [photoGalleryGroup]="{ index: 1 }">
                  <tr *ngFor="let template of templates">
                    <td>
                      <div
                        [photoGallery]="getThumbUrl(template.images[0], 'w2048wp')"
                        [photoGalleryCaption]="
                          template.name +
                          '<br>' +
                          (template.code ? ('product-template-selection.code' | translate) + template.code : '') +
                          '<br>' +
                          (template.ean ? ('product-template-selection.ean' | translate) + template.ean : '')
                        "
                      >
                        <div class="images-item">
                          <img
                            class="images-item-image"
                            [src]="getThumbUrl(template.images[0], 'w135wp')"
                            [alt]="template.name"
                          />
                        </div>
                      </div>
                    </td>
                    <td class="pl-1" (click)="selectTemplate(template)">
                      <span class="cursor-pointer link-bold">
                        {{ template.name ? template.name : '' }}
                      </span>
                    </td>
                    <td>
                      {{ template.manuCode }}
                    </td>
                    <td class="pr-1 text-right fixed-column-width">
                      <btn
                        [label]="'select'"
                        [classes]="['btn-second', 'btn-sm']"
                        (onEvent)="selectTemplate(template)"
                        data-cy="select-template"
                      ></btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</modal-container>
